import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {IPropsController} from '../Config/ProgressBar.types';
import ProgressBarView from '../View/ProgressBar.view';
const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});

export default function ProgressBar({progress, className = '', isTitle = true, customTitle = 'Completed'}: IPropsController) {

    const classes = useStyles();
    let title = progress.total ? `${customTitle} ${progress.index} of ${progress.total}` : `${Math.round(progress.value || 0,)}% Completed`;

    !isTitle && (title = '');
    progress.total && progress.index && (progress.value = parseInt(`${(progress.index / progress.total) * 100}`, 10));

    return <ProgressBarView className={className ? className : classes.root} value={progress.value} title={title} />;
}
